import { Box, ButtonGroup, Flex, HStack, IconButton, Text, Tooltip } from '@chakra-ui/react';
import { CommentMultiple, Plus } from '@/client/components/icons/ContinuIcons';

import { useAIAgentStore } from './AIAgentStore';
import { useListUserConversations } from './hooks/useListUserConversations';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export default function AIAgentHeader() {
  const { t } = useTranslation();
  const { setActiveTab, setCurrentConversationId } = useAIAgentStore();

  const { data: conversations } = useListUserConversations();

  const queryClient = useQueryClient();

  return (
    <Flex justifyContent="space-between" alignItems="center" paddingBottom={4} paddingTop={2.5}>
      <HStack spacing={3}>
        <Text
          fontSize="28px"
          fontWeight={600}
          style={{
            background: 'linear-gradient(to right, #C567EE, #FCB8AE)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          {t('aiAgent.header.title')}
        </Text>

        <Box
          bgGradient="linear(to-br, #B466F9, #EBB6BA)"
          borderRadius="4px"
          fontSize="12px"
          fontWeight={600}
          color="white"
          paddingX={1}
        >
          {t('aiAgent.header.beta')}
        </Box>
      </HStack>

      {conversations?.edges && conversations?.edges?.length > 0 && (
        <ButtonGroup size="sm">
          <Tooltip label={t('aiAgent.header.conversationHistory')} hasArrow>
            <IconButton
              variant="roundNeutralIcon"
              aria-label={t('aiAgent.header.conversationHistory')}
              icon={<CommentMultiple boxSize={4} />}
              onClick={() => {
                setActiveTab('history');
                setCurrentConversationId('');
              }}
            />
          </Tooltip>

          <Tooltip label={t('aiAgent.header.newChat')} hasArrow>
            <IconButton
              variant="roundNeutralIcon"
              aria-label={t('aiAgent.header.newConversation')}
              icon={<Plus />}
              onClick={() => {
                queryClient.refetchQueries({ queryKey: ['conversation'] });
                setActiveTab('conversation');
                setCurrentConversationId('');
              }}
            />
          </Tooltip>
        </ButtonGroup>
      )}
    </Flex>
  );
}
